






























































































import { Component, Vue } from "vue-property-decorator";
import { alarm, app, sensor } from "@/store";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import {
    computed,
    defineComponent,
    onMounted,
    ref
} from "@vue/composition-api";
import { ILocationFromParticle } from "../models/AlarmStatus";
import 'core-js';
import useTemperature from "@/store/useTemperature";
import TemperatureViewModel from "@/models/TemperatureViewModel";

export default defineComponent({
    name: "Home",
    components: {
        Battery: () =>
            import(/* webpackChunkName: "components" */ "./components/BatteryView.vue"),
        AlarmButton: () =>
            import(
    /* webpackChunkName: "components" */ "./components/ArmDisarmButton.vue"
            ),
        SensorItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/DefaultSensorListItem.vue"
            ),
        ShorePowerItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/ShorePowerListItem.vue"
            ),
        SmartPlugItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/SmartPlugListItem.vue"
            ),
        DoorSensorItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/DoorSensorListItem.vue"
            ),
        HatchSensorItem: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Sensors/HatchSensorListItem.vue"
            ),
        VoltageGraph: () =>
            import(
    /* webpackChunkName: "components" */ "./components/Dialogs/VoltageDialog.vue"
            )
    },
    setup(_, { root }) {
        const showGrafDialog1 = ref<boolean>(false);
        const showGrafDialog2 = ref<boolean>(false);
        const connectSensor = ref<AttachedDeviceModel>();
        const gpsLocationAge = ref<string>("");
        let lastGpsTime: Date | null = null;
        let lastHeardIntervalId: any | null = null;
        const { get } = useTemperature();
        const temperature = ref<string>("-.--");
        const accuracy = computed(() => { return alarm.gpsRadius; });

        const armed = computed(() => { return alarm.armed; });

        const power1 = computed(() => {
            if (
                alarm.alarmStatus != null &&
                alarm.alarmStatus.VSupplies != null &&
                alarm.alarmStatus.VSupplies[0] != null
            ) {
                const voltage = alarm.alarmStatus.VSupplies[0].V1;
                return voltage === "NotPresent" ? -1 : parseFloat(voltage);
            }
            return -1;
        });

        const power2 = computed(() => {
            if (
                alarm.alarmStatus != null &&
                alarm.alarmStatus.VSupplies != null &&
                alarm.alarmStatus.VSupplies[0] != null
            ) {
                const voltage = alarm.alarmStatus.VSupplies[0].V2;
                return voltage === "NotPresent" ? -1 : parseFloat(voltage);
            }
            return -1;
        });

        const voltageWarning1 = computed(() => {
            if (power1.value === -1) {
                return false;
            }
            if (power1.value < 11.8 || (power1.value > 16 && (power1.value > 29.5 || power1.value < 23.6))) {
                return true;
            }
            if (power1.value > 14.8) {
                return true;
            }
            return false;
        });

        const voltageWarning2 = computed(() => {
            if (power2.value === -1) {
                return false;
            }
            if (power2.value < 11.8 || (power2.value > 16 && (power2.value > 29.5 || power2.value < 23.6))) {
                return true;
            }
            if (power2.value > 14.8) {
                return true;
            }
            return false;
        });

        const hatchsensorModel = computed<AttachedDeviceModel>(() => {
            return getItem(1);
        });
        const shorePowerModel = computed<AttachedDeviceModel>(() => {
            return getItem(2);
        });
        const smartplugModel = computed<AttachedDeviceModel>(() => {
            return getItem(3);
        });
        const doorsensorModel = computed<AttachedDeviceModel>(() => {
            return getItem(10);
        });

        const getItem = (type: number): AttachedDeviceModel => {
            let model: AttachedDeviceModel = new AttachedDeviceModel();
            if (Array.isArray(sensor.devices) && sensor.devices.length > 0) {
                const foundModel = sensor.devices.find((value: AttachedDeviceModel) => {
                    return value.attachedDeviceTypeId === type;
                });
                if (foundModel != null) {
                    return foundModel;
                }
            }
            model.attachedDeviceTypeId = type;
            return model;
        };

        const latitude = computed<string>(() => {
            return alarm.lat ? alarm.lat.toString() : "-.--";
        });

        const longitude = computed<string>(() => {
            return alarm.lng ? alarm.lng.toString() : "-.--";
        });

        const latLetter = computed<string>(() => parseFloat(latitude.value) >= 0 ? "N" : "S");

        const lngLetter = computed<string>(() => parseFloat(longitude.value) >= 0 ? "E" : "W");

        //const temperature = computed<string>(() => {
        //    const tempInHex = alarm.alarmStatus.tempMtrs[0] ? alarm.alarmStatus.tempMtrs[0].tempC : "";
        //    return tempInHex ? "--.-" : (parseInt(tempInHex, 16) / 100).toFixed(1);
        //});

        const statusLoading = computed<boolean>(() => { return alarm.syncStatus; });

        const enroll = (model: AttachedDeviceModel) => { connectSensor.value = model; };

        const goToMob = () => {
            if (alarm.userLocReady) {
                root.$router.push({ name: "mob" });
            } else {
                root.$router.push({ name: "geo-permission", params: { destination: "mob" } });
            }
        };

        const generateTimeString = (days, hours, minutes, seconds) => {
            let timestring = "";

            if (days > 0) {
                timestring += `${days}d `;
            }

            if (hours > 0 || timestring !== "") {
                timestring += `${hours}h `;
            }

            if (minutes > 0 || timestring !== "") {
                timestring += `${minutes}m `;
            }

            timestring += `${seconds}s`;

            return timestring.trim();
        };

        const initTimer = (gps: ILocationFromParticle | null): void => {
            if (gps && gps.location && gps.location.last_heard) {
                const lastHeard = new Date(Date.parse(gps.location.last_heard));
                const utcTime = new Date(lastHeard.getTime() - lastHeard.getTimezoneOffset() * 60 * 1000);

                // Clear any existing interval timer if lastGpsTime has changed
                if (lastGpsTime && lastGpsTime !== lastHeard) {
                    clearInterval(lastHeardIntervalId);
                    lastHeardIntervalId = null;
                }

                // Update the count down every 1 second
                if (!lastHeardIntervalId) {
                    lastHeardIntervalId = setInterval(() => {
                        // Get today's date and time
                        const now = new Date();

                        // Find the distance between now and the count down date
                        const distance = now.getTime() - utcTime.getTime();

                        // Time calculations for days, hours, minutes and seconds
                        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                        const timestring = generateTimeString(days, hours, minutes, seconds);

                        gpsLocationAge.value = timestring;
                    }, 1000);
                }

                // Update lastGpsTime
                lastGpsTime = lastHeard;
            } else {
                gpsLocationAge.value = "---";
                clearInterval(lastHeardIntervalId);
                lastHeardIntervalId = null;
                lastGpsTime = null;
            }
        };

        const panel = computed<number>(() => {
            if (app.getHomePanelOpen) {
                console.log("app.getHomePanelIndex", app.getHomePanelIndex);
                return app.getHomePanelIndex;
            } else {
                console.log("app.getHomePanelIndex", -1);
                return -1;
            }
        });

        get().then((model: TemperatureViewModel) => {
            if (model.cabinTemperature != -273) {
                temperature.value = model.cabinTemperature.toFixed(1);
            }
        });
        
        onMounted(() => {
            alarm.getGeoLocation();
            alarm.SetDoorState(!doorsensorModel.value.alarm1);
            alarm.SetHatchState(!hatchsensorModel.value.alarm1);
            alarm.SetShorePowerState(shorePowerModel.value.alarm1);
            alarm.SetSmartPlugState(smartplugModel.value.alarm1);
            alarm.$watch(module => module.lastKnownLocation, initTimer);
        });

        return {
            armed,
            power1,
            power2,
            shorePowerModel,
            smartplugModel,
            doorsensorModel,
            hatchsensorModel,
            latitude,
            longitude,
            statusLoading,
            showGrafDialog1,
            showGrafDialog2,
            connectSensor,
            gpsLocationAge,
            enroll,
            temperature,
            accuracy,
            latLetter,
            lngLetter,
            voltageWarning1,
            voltageWarning2,
            goToMob,
            panel
        };
    }
});

@Component({})
class Home extends Vue {
    public showGrafDialog1: boolean = false;
    public showGrafDialog2: boolean = false;
    public connectSensor: AttachedDeviceModel | null = null;
}
